import SimpleBar from 'simplebar';

const customScrollbar = () => {
  const scrollbars = document.getElementsByClassName('js-scrollbar');

  [...scrollbars].forEach((scrollbar) => new SimpleBar(scrollbar, { autoHide: false }));
};

export default customScrollbar;
